module.exports = __webpack_public_path__ + "img/txf.actor.f3721e16.png";